import React from 'react';

const FLAGS = {
    gb: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <clipPath id="flag-gb-clip">
                <rect width="60" height="30" />
            </clipPath>
            <g clipPath="url(#flag-gb-clip)">
                <rect width="60" height="30" fill="#012169" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="2.5" />
                <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
                <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
            </g>
        </svg>
    ),
    en: null, // alias filled below
    ru: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="10" y="0"  fill="#fff" />
            <rect width="60" height="10" y="10" fill="#0039A6" />
            <rect width="60" height="10" y="20" fill="#D52B1E" />
        </svg>
    ),
    pt: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="30" fill="#009C3B" />
            <polygon points="30,3.5 55,15 30,26.5 5,15" fill="#FFDF00" />
            <circle cx="30" cy="15" r="6" fill="#002776" />
        </svg>
    ),
    es: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="7.5"  y="0"    fill="#AA151B" />
            <rect width="60" height="15"   y="7.5"  fill="#F1BF00" />
            <rect width="60" height="7.5"  y="22.5" fill="#AA151B" />
        </svg>
    ),
    de: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="10" y="0"  fill="#000000" />
            <rect width="60" height="10" y="10" fill="#DD0000" />
            <rect width="60" height="10" y="20" fill="#FFCE00" />
        </svg>
    ),
    it: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="20" height="30" x="0"  fill="#009246" />
            <rect width="20" height="30" x="20" fill="#FFFFFF" />
            <rect width="20" height="30" x="40" fill="#CE2B37" />
        </svg>
    ),
    fr: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="20" height="30" x="0"  fill="#0055A4" />
            <rect width="20" height="30" x="20" fill="#FFFFFF" />
            <rect width="20" height="30" x="40" fill="#EF4135" />
        </svg>
    ),
    sv: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="30" fill="#006AA7" />
            <rect width="60" height="6"  y="12" fill="#FECC00" />
            <rect width="6"  height="30" x="18" fill="#FECC00" />
        </svg>
    ),
    no: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="30" fill="#EF2B2D" />
            <rect width="60" height="10" y="10" fill="#FFFFFF" />
            <rect width="10" height="30" x="14" fill="#FFFFFF" />
            <rect width="60" height="6"  y="12" fill="#002868" />
            <rect width="6"  height="30" x="16" fill="#002868" />
        </svg>
    ),
    fi: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="30" fill="#FFFFFF" />
            <rect width="60" height="6"  y="12" fill="#003580" />
            <rect width="6"  height="30" x="18" fill="#003580" />
        </svg>
    ),
    da: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="30" fill="#C8102E" />
            <rect width="60" height="6"  y="12" fill="#FFFFFF" />
            <rect width="6"  height="30" x="18" fill="#FFFFFF" />
        </svg>
    ),
    hi: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="10" y="0"  fill="#FF9933" />
            <rect width="60" height="10" y="10" fill="#FFFFFF" />
            <rect width="60" height="10" y="20" fill="#138808" />
            <circle cx="30" cy="15" r="3.2" fill="none" stroke="#000080" strokeWidth="0.6" />
        </svg>
    ),
    tr: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="30" fill="#E30A17" />
            <circle cx="22" cy="15" r="6"   fill="#FFFFFF" />
            <circle cx="24" cy="15" r="4.8" fill="#E30A17" />
            <polygon points="32,11.5 33.5,14 36.5,14 34,15.7 35,18.5 32,17 29,18.5 30,15.7 27.5,14 30.5,14" fill="#FFFFFF" />
        </svg>
    ),
    uz: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="10" y="0"  fill="#0099B5" />
            <rect width="60" height="1"  y="10" fill="#CE1126" />
            <rect width="60" height="8"  y="11" fill="#FFFFFF" />
            <rect width="60" height="1"  y="19" fill="#CE1126" />
            <rect width="60" height="10" y="20" fill="#1EB53A" />
            <circle cx="14"   cy="5" r="2.6" fill="#FFFFFF" />
            <circle cx="15.4" cy="5" r="2.3" fill="#0099B5" />
        </svg>
    ),
    kk: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="30" fill="#00ABC2" />
            <circle cx="30" cy="15" r="4.5" fill="#FFD700" />
        </svg>
    ),
    ja: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="30" fill="#FFFFFF" />
            <circle cx="30" cy="15" r="9" fill="#BC002D" />
        </svg>
    ),
    ko: (
        <svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <rect width="60" height="30" fill="#FFFFFF" />
            <circle cx="30" cy="15" r="7" fill="#C60C30" />
            <path d="M 30 8 A 7 7 0 0 0 30 22 A 3.5 3.5 0 0 1 30 15 A 3.5 3.5 0 0 0 30 8 Z" fill="#003478" />
        </svg>
    ),
};
FLAGS.en = FLAGS.gb;

export default function Flag({ code, className = '' }) {
    const svg = FLAGS[code] || FLAGS.gb;
    return (
        <span
            className={`inline-block overflow-hidden rounded-sm border border-cyber-border/60 ${className}`}
            style={{ width: '1.4em', height: '1em', lineHeight: 0 }}
        >
            {React.cloneElement(svg, { width: '100%', height: '100%' })}
        </span>
    );
}
